import { z } from 'zod';

/**
 * The Creation Widget's identity field for the unified (Room-backed) create
 * flow — just "who are you meeting," since the host's own identity now comes
 * from their signed-in SSO session (features/auth), not a typed name field.
 */
const guestName = z
  .string()
  .trim()
  .min(1, "Add who you're meeting.")
  .max(120, 'Keep this under 120 characters.');

export const createRoomIdentitySchema = z.object({ guestName });
export type CreateRoomIdentityValues = z.infer<typeof createRoomIdentitySchema>;
